import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, AbstractControl, FormArray } from '@angular/forms';
import { PlannerDTO } from '../dto/PlannerDTO';
import { DashboardType } from '../enums/DashboardType.enum';
import { Router } from '@angular/router';
import { PlanStatus } from '../components/planner-edit/constants/PlanStatus.const';

@Injectable()
export class PlannerService {
  public PlannerDTO: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router
  ) {
    this.PlannerDTO = new PlannerDTO(this.fb).formGroup;
  }

  isPlanFormEditable(status) {
    return !(status === PlanStatus.Draft.key ||
      status === PlanStatus.PaasError.key ||
      status === PlanStatus.Error.key ||
      status === PlanStatus.Expired.key ||
      status === PlanStatus.PreviewReady.key ||
      status === PlanStatus.Archived.key)
  }

  redirectToList(advertiserId, marketId): void {
    if (advertiserId) {
      this.router.navigate([DashboardType.AdvertiserDashboard, advertiserId], {
        queryParams: {
          marketId: marketId
        }
      });
    } else {
      this.router.navigate([DashboardType.MarketDashboard, marketId]);
    }
  }

  markAllDescendantsAsTouched(control: AbstractControl, onlySelf: boolean = false) {
    control.markAsTouched({ onlySelf: true });

    if (!onlySelf) {
      if (control instanceof FormGroup) {
        Object.values((control as FormGroup).controls).forEach(val => this.markAllDescendantsAsTouched(val));
      } else if (control instanceof FormArray) {
        (control as FormArray).controls.forEach(val => this.markAllDescendantsAsTouched(val));
      }
    }
  }
}
